import styled from "styled-components";

export const MatrixWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: -10000;
`;

export const MatrixCanvas = styled.canvas`
    display: block;
    
    width: 100vw;
    height: 100vh;
`;
